import { createSafeJotaiSessionStorage } from '@heidi/utils/jotai-storage';
import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import type { DictateDesktopInstaller } from '../../contracts/desktop-download';

/** Whether the Dictate desktop download dialog is open. */
export const isDictateDesktopDownloadDialogOpenAtom = atom(false);

/**
 * Set by the `/dictate/get-started` entry before it hands off to sign-up (or
 * straight into the app), and consumed once the user lands authenticated and
 * the modal queue is clear. sessionStorage, like the shared-template import: it
 * survives the Auth0 round trip and the `/scribe/new-user` → `/scribe` hops that
 * strip query params, and dies with the tab so a stale intent never reopens the
 * dialog days later.
 */
export const pendingDictateDesktopDownloadAtom = atomWithStorage<boolean>(
  'heidi-pending-dictate-desktop-download',
  false,
  createSafeJotaiSessionStorage<boolean>(),
  { getOnInit: true }
);

/**
 * The build the visitor picked on the marketing page (its "Intel Chip", ".MSI"
 * … buttons), written by the `/dictate/get-started` entry together with the
 * pending flag and cleared when the host claims it. `null` — a generic "Try
 * Dictate" button — means the host detects the build for this computer. Read
 * through `isDictateDesktopInstaller`: sessionStorage is user-editable.
 */
export const requestedDictateDesktopInstallerAtom =
  atomWithStorage<DictateDesktopInstaller | null>(
    'heidi-requested-dictate-desktop-installer',
    null,
    createSafeJotaiSessionStorage<DictateDesktopInstaller | null>(),
    { getOnInit: true }
  );
